import { ChangeDetectionStrategy, Component, EventEmitter, inject } from '@angular/core';
import { ConfigResource } from '@df/catalog/config/config.resource';
import { App } from '@df/core/app';
import { Status } from '@df/core/status';
import { DfModal } from '@df/ui/modal/df-modal.decorator';
import { NDfModal } from '@df/ui/modal/df-modal.interface';
import { ModalRef } from '@df/ui/modal/modal-ref';
import { MODAL_DATA } from '@df/ui/modal/modal.service';
import { TranslationModule } from '@df/ui/translation/translation.module';
import { UiComponent } from '@df/ui/ui.component';
import { CMS_CONFIG_POS, IICmsConfigPosData } from 'projects/app-default/src/app/cms/config/pos.cms-config';
import { ModalLayoutRightComponent, NModalLayoutRight } from 'projects/app-default/src/app/ui/modal/modal-layout-right.component';
import { SkeletonLoaderComponent } from 'projects/app-default/src/app/ui/skeleton-loader/skeleton-loader.component';
import { ProductPosModalFormComponent } from './form/product-pos-modal-form.component';
export namespace NProductPosModal {
    export const MODAL_ID = 'product-pos-modal';
}
@DfModal({
    id: NProductPosModal.MODAL_ID,
    position: sizeName => (sizeName === 'X' || sizeName === 'L' ? 'right' : 'bottom'),
    config: size =>
        ['S'].includes(size)
            ? {
                  width: '100%',
                  maxWidth: '100vw',
                  height: '85%',
                  modalClass: 'p-a-0',
                  position: { bottom: '0' },
                  closeOnNavigation: true
              }
            : {
                  ...NModalLayoutRight.ModalConfig,
                  width: '31.7rem'
              },
    reopenPolicy: NDfModal.ReopenPolicy.wait,
    sizeRestriction: sizeId => ['S', 'M', 'L', 'X']
})
@Component({
    templateUrl: './product-pos-modal.html',
    standalone: true,
    imports: [ModalLayoutRightComponent, TranslationModule, ProductPosModalFormComponent, SkeletonLoaderComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProductPosModalComponent extends UiComponent {
    private modalRef = inject(ModalRef<ProductPosModalComponent>);
    protected app = inject(App);
    private configResource = inject(ConfigResource);
    protected buttonClick = new EventEmitter<void>();
    protected status?: Status = undefined;
    protected modalData = inject(MODAL_DATA) as { sku: string };
    protected posFormId?: string;
    protected isConfigLoaded = false;
    override async ngOnInit(): Promise<void> {
        await this.configResource.loadModelByUrl(CMS_CONFIG_POS);
        const config = this.configResource.getModelByUrl(CMS_CONFIG_POS) as IICmsConfigPosData;
        this.posFormId = config?.data?.content?.posFormId;
        this.isConfigLoaded = true;
        this.changeDetectorRef.detectChanges();
        super.ngOnInit();
    }
    protected close(): void {
        this.modalRef.close();
    }
    protected submit(): void {
        this.buttonClick.emit();
    }
    protected handleStatus(status): void {
        this.status = status;
        this.changeDetectorRef.detectChanges();
    }
}
